/* eslint-disable react/no-deprecated */
import React from 'react';
import { render } from 'react-dom';
import 'tippy.js/dist/tippy.css';
import 'react-tippy/dist/tippy.css';
import '../assets/scss/main.scss';
import './base.scss';
import 'common/metadataDeps';
import Root from './root/components/Root';

render(<Root />, document.getElementById('app-root'));
